import Close from '@ixigo/icons/Close';
import ButtonBase from '@ixigo/iui/ButtonBase';
import IconButton, { type IconButtonProps } from '@ixigo/iui/IconButton';
import ListItem, { type ListItemProps } from '@ixigo/iui/ListItem';
import ListItemIcon, { type ListItemIconProps } from '@ixigo/iui/ListItemIcon';
import type { OverrideProps } from '@ixigo/iui/utils';
import cn from '@repo/shared/utils/cn';

interface ComboboxListItemProps extends ListItemProps {}

function Item(props: ComboboxListItemProps) {
	return (
		<ButtonBase asChild>
			<ListItem
				alignItems="center"
				size="sm"
				disablePadding
				{...props}
				className={cn(
					'py-15 px-20 gap-15 hover:bg-transparent',
					props.className,
				)}
			/>
		</ButtonBase>
	);
}

function Icon({
	className,
	...props
}: OverrideProps<'div', ListItemIconProps>) {
	return (
		<ListItemIcon
			{...props}
			className={cn(
				'bg-tertiary border border-secondary rounded-10 items-center justify-center size-50px',
				className,
			)}
		/>
	);
}

function ClearButton({
	value,
	...props
}: IconButtonProps & { value?: string }) {
	if (!value) return null;
	return (
		<IconButton size="sm" {...props} edge="end">
			<Close />
		</IconButton>
	);
}

export const Combobox = {
	Item,
	Icon,
	ClearButton,
};
